/**
 * Район
 * @typedef {object} District
 * @property {object} direction
 * @property {number} id
 * @property {string} text - русскоязычное название
 * @property {string} type - тип гео-объекта (всегда 'district')
 */

/**
 * Округ (включает в себя несколько районов)
 * @typedef {District} Okrug
 * @property {[District]} childs
 * @property {{x, y}} place - позиция в колонках
 * @property {?string} name - русскоязычное название округа (заменяет то, что приходит с бэка)
 */

import * as _ from 'lodash';
import * as moscowDistricts from './moscow-districts.json';
import collectionUtils from '../../../common/collection-utils';
import utils from '../../../../serp/services/utils';
import {GEO_TYPES} from '../../../../serp/constants';

angular.module('cian.districtBrowser').controller('DistrictBrowserCtrl', [
  '$scope',
  '$uibModalInstance',
  'DistrictBrowserService',
  'RegionUtilsService',
  'regionWithDistricts',
  'geo',
  'newMoscow',
  'AnalyticsService',
  function ($scope,
            $uibModalInstance,
            DistrictBrowserService,
            RegionUtilsService,
            regionWithDistricts,
            geo,
            newMoscow,
            AnalyticsService) {

    let selectedDistricts = _.filter(geo, {type: GEO_TYPES.DISTRICT});

    // Utils

    const updateGeo = () => collectionUtils.updateSubsetOfCollectionInPlace(
      geo,
      selectedDistricts,
      [GEO_TYPES.DISTRICT],
    );

    /** @param {[District]} districts */
    const selectDistricts = districts => {
      selectedDistricts.push(...districts);
      updateGeo();
    };

    /** @param {District} district */
    const deselectDistrict = district => {
      _.remove(selectedDistricts, {id: district.id});
      updateGeo();
    };


    // Initialization

    this.includeNewMoscow = newMoscow;

    this.isMoscowRegion = () => RegionUtilsService.isMoscowOrMO([regionWithDistricts]);

    this.isLoading = true;

    let apiRequest = DistrictBrowserService.getDistrictsTree(regionWithDistricts).then(response => {
      this.districtsHaveParents = response.data.some(okrug => okrug.childs.length > 0);
      if (this.districtsHaveParents) {
        const okrugs = response.data.map(okrug => ({
          id: okrug.id,
          text: okrug.name,
          type: GEO_TYPES.DISTRICT,
          direction: okrug.direction,
          childs: okrug.childs.map(district => ({
            id: district.id,
            text: district.name,
            type: GEO_TYPES.DISTRICT
          })),
        }));

        if (this.isMoscowRegion()) {
          // Разбиваем по столбцам
          this.scheme = okrugs.reduce((result, okrug) => {
            const okrugInfo = moscowDistricts[okrug.direction.code] || moscowDistricts[okrug.id];

            if (okrugInfo) {
              okrug.place = {
                x: okrugInfo.pos[0],
                y: okrugInfo.pos[1],
              };
              okrug.name = okrugInfo.name || okrug.name;
            } else {
              okrug.place = {
                x: 0,
                y: 999,
              };
            }

            result[okrug.place.x].push(okrug);
            return result;
          }, [[], [], [], []]);

          // Сортируем округа внутри столбцов
          this.scheme.forEach(schemeItem => {
            schemeItem.sort((a, b) => a.place.y - b.place.y);
          });
        } else {
          this.scheme = utils.splitArrayInNArraysByLength(okrugs, 'childs');
        }
      } else {
        const districts = response.data.map(d => ({
          ...d,
          text: d.name,
          type: GEO_TYPES.DISTRICT,
        }));
        this.scheme = utils.splitArrayInNArrays(districts, 4);
      }
    });

    apiRequest.finally(() => (this.isLoading = false));

    // Public methods

    /** @param {District} district */
    this.isInSelected = district => geo.some(item => item.type === GEO_TYPES.DISTRICT && item.id === district.id);

    /** @param {District} district */
    this.toggleDistrict = district => {
      if (this.isInSelected(district)) {
        deselectDistrict(district);
      } else {
        selectDistricts([district]);
      }
    };

    this.save = () => {
      let selectedCount = selectedDistricts.length;
      if (!_.isNil(_.get(this.includeNewMoscow, 'value'))) {
        selectedCount++;
      }
      AnalyticsService.trackCA('Listing', 'popup_district_save', String(selectedCount), {});
      $uibModalInstance.close();
    }
  }]);



// WEBPACK FOOTER //
// ./src/components/district-browser/src/scripts/cian.district-browser.ctrl.js